<tag-input [ngModel]="valueAsTagModels" [separatorKeyCodes]="separatorKeys" [placeholder]="''"
  [secondaryPlaceholder]="''" (onAdd)="onItemAdded($event)" (onRemove)="onItemRemove($event)" theme='bootstrap'
  [validators]="validators" [errorMessages]="customErrors" data-testid="tag-string-input">
</tag-input>
<!--Only letters pattern validation  -->
@if (OnlyLettersAllowedError) {
  <div class="invalid-feedback d-block" translate="Error.OnlyLettersAllowed">
  </div>
}
<!--Only letters and numbers pattern validation  -->
@if (OnlyLettersAndNumbersAllowedError) {
  <div class="invalid-feedback d-block" translate="Error.OnlyLettersAndNumbersAllowed">
  </div>
}
<!--Only lowercase allowed pattern validation  -->
@if (OnlyLowerCaseAllowed) {
  <div class="invalid-feedback d-block" translate="Error.OnlyLowerCaseAllowed">
  </div>
}